<template>
  <div id="contenedor-main-auditoria-informe-respuestas">
    <v-container fluid>
      <v-card flat class="mb-4 rounded-lg">
        <v-card-text class="px-0 py-1">
          <titulo-tool-bar
            titulo="Respuestas"
            nombreRuta="auditoriaInformes"
            regresar>
            <template v-slot:end>
              <span class="subtitle-2 text--secondary">
                Informe: {{ getAuditoriaInforme.nombre }}
              </span>
            </template>
          </titulo-tool-bar>
          <v-toolbar flat dense
          v-if="mixValidaScopesActions(1)">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              rounded
              @click="mostrarAgregarInformeRespuesta = !mostrarAgregarInformeRespuesta">
              <v-icon left small>
                mdi-plus
              </v-icon>
              Nueva
            </v-btn>
          </v-toolbar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <!-- Loader -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody"
          ></v-skeleton-loader>
          <listado
            v-if="!$apollo.loading"
            :solo-lectura="soloLectura"
            :listadoRespuestas="getAuditoriaInformeRespuestas"
            :informe="getAuditoriaInforme"
            >
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-if="!$apollo.loading && mostrarAgregarInformeRespuesta"
      v-model="mostrarAgregarInformeRespuesta"
      scrollable
      persistent
      width="750px">
      <Nueva
        :informe="getAuditoriaInforme"
        v-on:cerrar="mostrarAgregarInformeRespuesta = !mostrarAgregarInformeRespuesta">
      </Nueva>
    </v-dialog>
    <v-dialog
      v-if="!$apollo.loading && mostrarAgregarDetalleRespuesta"
      v-model="mostrarAgregarDetalleRespuesta"
      scrollable
      persistent
      width="750px">
      <NuevoDetalle
        :respuesta="estaRespuesta"
        :informe="getAuditoriaInforme"
        v-on:cerrar="mostrarAgregarDetalleRespuesta = !mostrarAgregarDetalleRespuesta">
      </NuevoDetalle>
    </v-dialog>
    <v-dialog
      v-if="esteDetalle"
      v-model="mostrarVentanaDocumentosDetalle"
      persistent
      width="750px">
      <v-card>
        <v-card-title class="secondary--text">
          Archivos del Detalle de la Respuesta
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrar">
            <v-icon
              class="secondary--text"
              large>
              highlight_off
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2 mb-2"></v-divider>
        <v-card-text>
          <listado-documentos-detalle
            :detalle="esteDetalle"
            :idRespuesta="esteDetalle.idAuditoriaInformeRespuesta"
            v-on:cerrar="cerrar">
          </listado-documentos-detalle>
          <div class="mt-3">
            <h3>
              Documentos seguimiento
            </h3>
            <ListadoSeguimientosDetalle
              :id-detalle="esteDetalle.idAuditoriaInformeObservacionDetalle"
              :id-respuesta-detalle="esteDetalle.id"
              :solo-lectura="true">
            </ListadoSeguimientosDetalle>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cerrar"
            class="mr-3">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import AUDITORIA_INFORME from '@/graphql/querys/administracion/auditorias/auditoriaInforme.gql';
import AUDITORIA_INFORME_RESPUESTAS from '@/graphql/querys/administracion/auditorias/auditoriaInformeRespuestas.gql';
import listado from '@/views/administracion/auditorias/auditoria/informes/respuestas/listado/Main.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import Nueva from '@/components/administracion/auditorias/respuestas/Nueva.vue';
import NuevoDetalle from '@/components/administracion/auditorias/respuestas/detalles/Nuevo.vue';
import ListadoDocumentosDetalle from '@/components/administracion/auditorias/respuestas/detalles/documentos/ListadoDocumentos.vue';
import ListadoSeguimientosDetalle from '@/components/administracion/auditorias/observaciones/detalles/respuestas/Listado.vue';
import CustomButton from '@/components/buttons/Button.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainAuditoriaInformeObservaciones',
  props: {
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      mostrarAgregarInformeRespuesta: false,
      mostrarAgregarDetalleRespuesta: false,
      mostrarVentanaDocumentosDetalle: false,
      estaRespuesta: null,
      esteDetalle: null,
    };
  },
  components: {
    Nueva,
    NuevoDetalle,
    TituloToolBar,
    listado,
    ListadoDocumentosDetalle,
    ListadoSeguimientosDetalle,
    CustomButton,
  },
  apollo: {
    auditoriaInformeRespuestas: {
      query: AUDITORIA_INFORME_RESPUESTAS,
      variables() {
        return {
          idInforme: this.$route.params.idInforme,
        };
      },
    },
    auditoriaInforme: {
      query: AUDITORIA_INFORME,
      variables() {
        return {
          id: this.$route.params.idInforme,
        };
      },
    },
  },
  methods: {
    cerrar() {
      this.mostrarVentanaDocumentosDetalle = false;
      this.esteDetalle = null;
    },
  },
  mounted() {
    eventBus.$on('agregar-detalle-respuesta', (respuesta) => {
      this.estaRespuesta = respuesta;
      this.mostrarAgregarDetalleRespuesta = true;
    });
    eventBus.$on('documentos-detalle', (detalle) => {
      this.esteDetalle = detalle;
      this.mostrarVentanaDocumentosDetalle = true;
    });
  },
  computed: {
    getAuditoriaInformeRespuestas() {
      if (!this.auditoriaInformeRespuestas) return [];
      return this.auditoriaInformeRespuestas
        .slice()
        .sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
        .map((respuesta) => {
          respuesta.detalles.sort((a, b) => (`${a.observacionDetalle.auditoriaObservacion.numero}`)
            .localeCompare(b.observacionDetalle.auditoriaObservacion.numero));
          return respuesta;
        })
        .map((respuestas) => ({
          ...respuestas,
        }));
    },
    getAuditoriaInforme() {
      if (!this.auditoriaInforme) return [];
      return this.auditoriaInforme;
    },

  },

};
</script>
